<template>
  <div :class="{'has-logo':showLogo}" class="side-nav">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <!--
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :active-text-color="variables.menuActiveText"
       -->
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item v-for="route in activeSideBar" :key="route.path" :item="route" :base-path="route.path" />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import companyManageRouter from '@/views/companyManage/router/index'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'

export default {
  components: { SidebarItem, Logo },
  computed: {
    ...mapGetters([
      'permission_routes',
      'sidebar'
    ]),
    activeMenu() {
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      return path
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    },
    activeSideBar() {
      const match = this.$route.matched
      console.log('match', this.$route)
      if (match.find((item) => item.path === '/companyManage')) {
        return [companyManageRouter]
      } else {
        return this.permission_routes.filter((item) => {
          return !item.path.startsWith('/companyManage')
        })
      }
    }
  },
  mounted() {
    console.log('match', this.$route)
  }
}
</script>

<style lang="scss" scoped>
  .side-nav {
    /deep/.el-submenu__title {
      display: flex;
      align-items: center;
      .nav-icon-hover {
        display: none;
      }
      &:hover {
        .nav-icon-hover {
          display: inline-block;
        }
        .nav-icon {
          display: none;
        }
      }
    }
    /deep/.scrollbar-wrapper {
      .el-scrollbar__view {
        >.el-menu {
          padding-bottom: 120px !important;
        }
      }
    }
    /deep/.submenu-title-noDropdown {
      display: flex;
      align-items: center;
      .nav-icon-hover {
        display: none;
      }
      &:hover {
        .nav-icon-hover {
          display: inline-block;
        }
        .nav-icon {
          display: none;
        }
      }
    }
    /deep/ .el-menu-item {
      .nav-icon-hover {
        display: none;
      }
    }
  }
</style>
